export default "__VITE_ASSET__q48bWGTe__"